import { ReservationServiceItem } from './serviceItem';
import { CustomerType } from './customerAccount';

export interface ReservationDriver {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface ReservationCustomer {
  id: number;
  type: CustomerType;
  displayName: string;
  legalName?: string | null;
  contactPersonName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  taxId?: string | null;
  registrationNumber?: string | null;
  streetAddress?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  notes?: string | null;
  active?: boolean;
}

export interface Reservation {
  id: number;
  reservationNumber: string;
  vehicle: {
    id: number;
    make: string;
    model: string;
    year: number;
    licensePlate?: string;
    type: string;
    dailyRate: number;
    imageUrls: string[];
    companyLocationId?: number | null;
    companyLocationName?: string | null;
  };
  driver?: ReservationDriver | null;
  driverId?: number | null;
  customerSameAsDriver?: boolean;
  customerId?: number | null;
  customer?: ReservationCustomer | null;
  rentalTypeId?: number | null;
  // Guest driver information (for non-authenticated bookings)
  guestDriverName?: string;
  guestDriverEmail?: string;
  guestDriverPhone?: string;
  company: {
    id: number;
    companyName: string;
    email: string;
    phoneNumber: string;
  };
  startDate: string;
  endDate?: string | null;
  pickupTime?: string;
  returnTime?: string;
  returnDateUnknown?: boolean;
  pickupDate: string;
  returnDate?: string | null;
  pickupLocationId?: number | null;
  returnLocationId?: number | null;
  pickupLocation: string;
  returnLocation: string;
  totalDays: number;
  dailyRate: number;
  subtotal?: number;
  totalAmount: number;
  status: ReservationStatus;
  insuranceIncluded: boolean;
  insuranceDailyRate: number;
  depositRequired: number;
  depositPaid: number;
  notes: string;
  /** Pickup mileage in kilometers (km). IMPORTANT: All mileage values must be in kilometers, never in miles. */
  pickupMileage?: number;
  /** Return mileage in kilometers (km). IMPORTANT: All mileage values must be in kilometers, never in miles. */
  returnMileage?: number;
  fuelLevelPickup?: string;
  fuelLevelReturn?: string;
  vehicleConditionPickup?: string;
  vehicleConditionReturn?: string;
  additionalFees?: number;
  serviceItems?: ReservationServiceItem[];
  createdAt: string;
  updatedAt: string;
}

export enum ReservationStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW'
}

export interface ReservationCreateRequest {
  vehicleId: number;
  driverId?: number;
  customerSameAsDriver?: boolean;
  customerId?: number | null;
  rentalTypeId?: number | null;
  startDate: string;
  endDate?: string;
  pickupTime?: string;
  returnTime?: string;
  returnDateUnknown?: boolean;
  pickupLocationId?: number;
  returnLocationId?: number;
  pickupLocation?: string;
  returnLocation?: string;
  insuranceIncluded?: boolean;
  notes?: string;
}

export interface ReservationUpdateRequest {
  vehicleId?: number;
  driverId?: number;
  customerSameAsDriver?: boolean;
  customerId?: number | null;
  rentalTypeId?: number | null;
  startDate?: string;
  endDate?: string | null;
  pickupTime?: string;
  returnTime?: string | null;
  returnDateUnknown?: boolean;
  pickupLocationId?: number | null;
  returnLocationId?: number | null;
  pickupLocation?: string | null;
  returnLocation?: string | null;
  insuranceIncluded?: boolean;
  notes?: string;
  status?: ReservationStatus;
  pickupMileage?: number;
  returnMileage?: number;
  fuelLevelPickup?: string;
  fuelLevelReturn?: string;
  vehicleConditionPickup?: string;
  vehicleConditionReturn?: string;
  additionalFees?: number;
}
